import { lazy } from 'react';

export const InwardList = lazy(() => import('./inward/InwardList'));
export const StockAvailabilityList = lazy(() => import('./stockAvailability/StockAvailabilityList'));
export const PricingList = lazy(() => import('./pricing/PricingList'));
export const OutwardList = lazy(() => import('./outward/OutwardList'));